const SOFOLOGY_BASKET_TITLE = 'Sofology Basket';
const SOFOLOGY_CHECKOUT_TITLE = 'Sofology Checkout';
const SOFOLOGY_PAYMENT_TITLE = 'Sofology Payment';
const SOFOLOGY_FINANCE_TITLE = 'Sofology Finance Application';
const SOFOLOGY_ORDER_CONFIRMATION_TITLE = 'Sofology Order Confirmation';
const SOFOLOGY_ADD_TO_BASKET_TITLE = 'Add items from Room Planner';

function createRouter(basePath: string) {
    return {
        basket: { path: `${basePath}/`, exact: true, title: SOFOLOGY_BASKET_TITLE },
        deliveryDetails: { path: `${basePath}/checkout/address`, exact: true, title: SOFOLOGY_CHECKOUT_TITLE },
        deliveryDate: { path: `${basePath}/checkout/eca`, exact: true, title: SOFOLOGY_CHECKOUT_TITLE },
        payment: { path: `${basePath}/checkout/card`, exact: true, title: SOFOLOGY_PAYMENT_TITLE },
        dataProtectionNotice: { path: `${basePath}/checkout/dpn`, exact: true, title: SOFOLOGY_FINANCE_TITLE },
        financeApplication: { path: `${basePath}/checkout/finance`, exact: true, title: SOFOLOGY_FINANCE_TITLE },
        financeApplicationStepTwo: { path: `${basePath}/checkout/finance/step2`, exact: true, title: SOFOLOGY_FINANCE_TITLE },
        financeApplicationStepThree: { path: `${basePath}/checkout/finance/step3`, exact: true, title: SOFOLOGY_FINANCE_TITLE },
        financeApplicationStepFour: { path: `${basePath}/checkout/finance/step4`, exact: true, title: SOFOLOGY_FINANCE_TITLE },
        external: {
            siteHome: { path: '/', exact: true },
            newIn: { path: '/new-in', exact: true },
            login: { path: '/mysofology-login', exact: true }
        },
        orderPage: { path: `${basePath}/checkout/order`, exact: true, title: SOFOLOGY_PAYMENT_TITLE },
        orderSummaryPage: { path: `${basePath}/checkout/summary`, exact: true, title: SOFOLOGY_ORDER_CONFIRMATION_TITLE },
        financeApplicationStatusPage: { path: `${basePath}/checkout/status`, exact: true, title: SOFOLOGY_FINANCE_TITLE },
        completeResetPasswordPage: { path: `${basePath}/checkout/complete-restore-password`, exact: false, title: SOFOLOGY_CHECKOUT_TITLE },
        addToCart: { path: `${basePath}/addtocart`, exact: true, title: SOFOLOGY_ADD_TO_BASKET_TITLE },
    };
}

export let routes = createRouter('');

export function configureRoutes(basePath: string) {
    routes = createRouter(basePath || '');
}